import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import I18NextHttpBackend from 'i18next-http-backend';

// Initial localization
const urlBreakdown = window.location.pathname.split('/');
const initialLocalization = `${urlBreakdown[2]}-${urlBreakdown[1].toUpperCase()}`;

// Backend
const backend = {
  loadPath: `/{{ns}}/{{lng}}.json`,
  allowMultiLoading: true,
};

i18next.use(I18NextHttpBackend).use(initReactI18next).init({
  lng: initialLocalization,
  fallbackLng: 'en-XZ',
  load: 'currentOnly',
  partialBundledLanguages: true,
  backend,
});
